import { Directive } from '@angular/core';

/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
@Directive({
	selector: `[flx-dialog-actions], flx-dialog-actions, [flxDialogActions]`,
	host: { class: 'flx-dialog-actions' }
})
export class DialogActionsDirective {}
